'use strict';

var React = require('react');
var PureRenderMixin = require('react').addons.PureRenderMixin;

var ReactForms = require('react-forms');

var Layout = require('ofs/forms/layout/layout');
var Row = require('ofs/forms/layout/row');
var Column = require('ofs/forms/layout/column');
var Group = require('ofs/forms/layout/group');

var FormElement = ReactForms.Element;

var topicLayouts = {
  'search_enquiry': require('../mappings/search').layout,
  'booking_enquiry': require('../mappings/booking').layout,
  'host_enquiry': require('../mappings/host').layout,
  'general_enquiry': require('../mappings/general').layout
};

var contactLayouts = {
  'email': require('../mappings/email').layout,
  'call': require('../mappings/telephone').layout
};


var buildLayout = function(topic, contactPreference) {
  var topicLayout = topicLayouts[topic];
  var contactLayout = contactLayouts[contactPreference];

  return React.createClass({
    mixins: [PureRenderMixin],

    render: function() {
      var value = this.props.value;
      return (
        <Layout>
          <Group>
            <Row><Column size="full"><FormElement value={value.get('enquiry_option')} /></Column></Row>
          </Group>
          {topicLayout(value)}
          <Group>
            <Row><Column size="full"><FormElement value={value.get('message')} /></Column></Row>
            <Row>
              <Column size="full">
                <FormElement
                  className="bdd-enquire-modal-button-group-contact"
                  value={value.get('contact_preference')}
                />
            </Column>
            </Row>
            {contactLayout(value)}
          </Group>
        </Layout>
      );
    }
  });
};


module.exports = buildLayout;



/** WEBPACK FOOTER **
 ** ./static/js/onefinestay/components/contact/generic/layout.jsx
 **/